import {
    createSlice,
    PayloadAction,
} from "scholastic-client-components/src/SharedPackages/reduxToolkit"
import {APIStatus} from "scholastic-client-components/src/types/APITypes"
import {LocalesResponse} from "../api/authAPI"

interface SliceState {
    status: APIStatus
    locales?: {id: string; name: string}[]
}

const initialState: SliceState = {
    status: APIStatus.Initial,
}

export const changeLanguageSlice = createSlice({
    name: "changeLanguage",
    initialState,
    reducers: {
        startFetch(state: SliceState) {
            state.status = APIStatus.Loading
        },
        failFetch(state: SliceState) {
            state.status = APIStatus.Failure
        },
        successFetch(state: SliceState, action: PayloadAction<LocalesResponse>) {
            state.locales = action.payload.locales
            state.status = APIStatus.Success
        },
        setSuccessStatus(state: SliceState) {
            state.status = APIStatus.Success
        },
        reset() {
            return initialState
        },
    },
})

interface Store {
    changeLanguage: SliceState
}

export const changeLanguageSelectors = {
    getStatus: (state: Store) => state.changeLanguage.status,
    getData: (state: Store) => state.changeLanguage,
}
